import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Button, Dropdown, Menu, Icon, Select, Modal, Popover ,Progress} from "antd";
// import { Row, Col, Button, Dropdown, Menu, Icon, Select, Modal, Progress } from "antd";
import Copyable from "../../components/common/Copyable";
import {
  fetchOrderReferences,
  mawbConnections,
  updateOrderDetails_v2,
} from "../../api/OrdersApi";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import ReusableInput from "./ReusableInput";
import { AlertWarningIcon, RefNumTooltipIcon } from "../../common/CustomIcon";
import "../../../stylesheets/CreateOrderSidebar.scss";
import InfoTooltip from "./InfoTooltip";
import Button_v2 from "./Button_v2";
import ModalComponent from "./Modal_v2"
import CloseIcon from "../../../assets/images/IconClose.svg";
import { OrgContext } from "../../context/OrgContext";
import SuborderModal from "./SuborderModal";
import { alertMessage } from "../../common/Common";
import { renderAlertMessage } from "../../helpers/common";
import CustomerOrderDetails from "../../components/orders/CustomerOrderDetails";
import _ from "lodash";
import { getAccountConfigs } from "../../helpers/api_calls";
import useItNumberSync from "../../hooks/useItNumberSync";

function ReferenceNumberSectionView({ currentOrder, currentOrg ,consolidatedData,setActiveKey,orderResponse,doRefreshDetails,organizationSettings, isLocked = false, updateReferences, orgRules = {}}) {
  const [modalField, setModalField] = useState("");
  const [referencesData, setReferencesData] = useState([]);
  const [selectedRef, setSelectedRef] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDropdown, setIsDropdown] = useState(false);
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [skipWarnHawbUniqueness, setSkipWarnHawbUniqueness] = useState(false);
  const [warningMessage, setWarningMessage] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [hoveredField, setHoveredField] = useState(null);
  const [isModalOpenProgress, setIsModalOpenProgress] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const orgData = useContext(OrgContext);
  const [warningMessages, setWarningMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [lineHaulData, setLineHaulData] = useState({ id: "", number: "" });
  const [totalOrders, setTotalOrders] = useState(0);
  const [completedOrders, setCompletedOrders] = useState(0);
  const [data, setData] = useState(consolidatedData);
  const [inputValue, setInputValue] = useState({
    hawb: "",
    mawb: "",
    it_number: "",
    reference_1: "",
    reference_1_type: "Ref 1 Type",
    reference_2: "",
    reference_2_type: "Ref 2 Type",
    references: [],
  });
  const [config, setConfig] = useState({}) 
  const [locked, setLocked] = useState(false); 
  const [sharedItNumber, setSharedItNumber] = useItNumberSync(currentOrder?.customer_order_details?.customer_order_id);
  const showItNumber = currentOrg?.code === "MWE";
//   useEffect(() => {
//     //if (orderResponse?.customer_order_details?.is_locked !== undefined) {
//         setLocked(isLocked);
//     //}
// }, [isLocked]); // orderResponse

  useEffect(() => {
    if (currentOrder?.customer_order_details) {
      const savedItNumber = currentOrder.customer_order_details.it_number ?? currentOrder?.label_info?.it_number ?? "";
      setInputValue({
        hawb: currentOrder.customer_order_details.hawb || "",
        mawb: currentOrder.customer_order_details.mawb || "",
        it_number: sharedItNumber ?? savedItNumber,
        reference_1: currentOrder.customer_order_details.reference_1 || "",
        reference_1_type:
          currentOrder.customer_order_details.reference_1_type || "Ref 1 Type",
        reference_2: currentOrder.customer_order_details.reference_2 || "",
        reference_2_type:
          currentOrder.customer_order_details.reference_2_type || "Ref 2 Type",
        references: currentOrder.customer_order_details.references || [],
      });
    }
  }, [currentOrder?.customer_order_details, currentOrder?.label_info?.it_number]);

  useEffect(() => {
    if (sharedItNumber === undefined) return;

    setInputValue((prev) => (
      prev.it_number === sharedItNumber ? prev : { ...prev, it_number: sharedItNumber }
    ));
  }, [sharedItNumber]);

  const handleSelectChange = (value, fieldName) => {
    setInputValue((prev) => ({
      ...prev,
      [fieldName]: 
        typeof value === "string"
          ? value?.toUpperCase() 
          : Array?.isArray(value)
          ? value?.map((item) => (typeof item === "string" ? item?.toUpperCase() : item))
          : value,
    }));
  };

  useEffect(() => {
    if (orderResponse?.account?.account_id) {
      fetchAccountConfig()
    }
  },[orderResponse])

  const fetchAccountConfig = async() => {
    try {
        const result = await getAccountConfigs(orderResponse?.account?.account_id, orderResponse?.customer_order_details?.organization_id || currentOrg?.id);
        if (result.success) {
          setConfig(result.data || {})         
        }
      } catch (error) {
        console.error('Error using fetched data:', error);
      }  
    }

    useEffect(() => {
      setData(consolidatedData);
      setTotalOrders(consolidatedData.length);
      setCompletedOrders(consolidatedData.filter(order => order.status === "COMPLETED").length);
    }, [consolidatedData]);

  const handleClick = () => {
    setActiveKey('subOrders');
    setIsModalOpenProgress(false);
   
  };
  const getFilteredReferences = (fieldName) => {
    return referencesData.filter((rec) => {
      if (fieldName === "reference_1_type") {
        return rec.order_reference_type !== inputValue.reference_2_type;
      } else if (fieldName === "reference_2_type") {
        return rec.order_reference_type !== inputValue.reference_1_type;
      }
      return true;
    });
  };

  useEffect(() => {
    const accountId = currentOrder?.account?.account_id;
    if (accountId) {
      getOrderReferences();
    } else {
    }
  }, [currentOrder?.account?.account_id]);

  useEffect(() => {
    if (currentOrder?.type_of_order === "T") {
      const parentLhOrder = currentOrder?.customer_order_details?.parent_lh_order;
  
      if (parentLhOrder && typeof parentLhOrder === "object") {
        setLineHaulData({
          id: parentLhOrder.id,  
          number: parentLhOrder.lh_order_number,
        });
      }
    }
  }, [currentOrder]);
  
  

  const getOrderReferences = () => {
    fetchOrderReferences(currentOrg.id, currentOrder.account.account_id).then(
      (result) => {
        if (result.success) {
          setReferencesData(result.references || []);
        } else {
          renderAlertMessage(result.errors);
          setReferencesData([]);
        }
      }
    );
  };

  useEffect(() => {
    const references = currentOrder?.customer_order_details?.references;
    if (references && Array.isArray(references) && references.length > 0) {
      setSelectedRef(references);
    } else {
      setSelectedRef([]);
    }
  }, [currentOrder?.customer_order_details?.references]);

  const handleSave = async () => {
    const mandatoryFields = (orgRules?.org_billing_rules?.require_fields_as_mandatory || "")
      .split(",")
      .map((f) => f.trim().toLowerCase())
      .filter((f) => f.length > 0);
    const isHawbRequired = mandatoryFields.includes("hawb");
    const isMawbRequired = mandatoryFields.includes("mawb");
    const isItNumberRequired = showItNumber && mandatoryFields.includes("it_number");
    const isRef1Required = mandatoryFields.includes("reference_1");
    const isRef2Required = mandatoryFields.includes("reference_2");
     const referencesData = {
      ...inputValue,
      hawb: (inputValue?.hawb || "").trim(),
      mawb: (inputValue?.mawb || "").trim(),
      it_number: (inputValue?.it_number || "").trim(),
      reference_1: (inputValue?.reference_1 || "").trim(),
      reference_2: (inputValue?.reference_2 || "").trim(),
    }

    const {
      hawb: hawbVal,
      mawb: mawbVal,
      it_number: itNumberVal,
      reference_1: ref1Val,
      reference_2: ref2Val
    } = referencesData;

    if (isHawbRequired && !hawbVal) {
      renderNotification("HAWB is required", "error");
      return false;
    }
    if (isMawbRequired && !mawbVal) {
      renderNotification("MAWB is required", "error");
      return false;
    }
    if (isItNumberRequired && !itNumberVal) {
      renderNotification("IT Number is required", "error");
      return false;
    }
    if (isRef1Required && !ref1Val) {
      renderNotification((inputValue.reference_1_type || "Reference 1")+" is required", "error");
      return false;
    }
    if (isRef2Required && !ref2Val) {
      renderNotification((inputValue.reference_2_type || "Reference 2")+" is required", "error");
      return false;
    }
    const payload = {
      customer_order_params: {
        customer_order_id: currentOrder.id,
        warehouse_id: currentOrder?.customer_order_details?.warehouse_id || "",
        organization_id: currentOrg?.id || "",
        location_id: location?.id || location?.location_id || "",
      },
      ref_block_params: {
        hawb: hawbVal,
        mawb: mawbVal,
        it_number: itNumberVal,
        reference_1: ref1Val,
        reference_1_type: inputValue.reference_1_type,
        reference_2: ref2Val,
        reference_2_type: inputValue.reference_2_type,
        references: inputValue.references,
        skip_warn_hawb_uniqness: skipWarnHawbUniqueness,
      },
      label_info: {
        it_number: itNumberVal,
      },
    };
    const result = await updateOrderDetails_v2(currentOrder.id, payload);

      if (result.success) {
        renderNotification(
          `Order ${currentOrder.customer_order_details.customer_order_number} details has been updated`,
          "success"
        );

        setModalField("");
        setSkipWarnHawbUniqueness(false);
        
        // Update the local state 
        if (result.response?.ref_block_params) {
          const refData = result.response.ref_block_params;
          setInputValue({
            hawb: refData.hawb || "",
            mawb: refData.mawb || "",
            it_number: refData.it_number || "",
            reference_1: refData.reference_1 || "",
            reference_1_type: refData.reference_1_type || "",
            reference_2: refData.reference_2 || "",
            reference_2_type: refData.reference_2_type || "",
            references: refData.others || [],
          });
          updateReferences({
            references: {
              hawb: refData.hawb,
              mawb: refData.mawb,
              it_number: refData.it_number,
              reference_1: refData.reference_1,
              reference_1_type: refData.reference_1_type,
              reference_2: refData.reference_2,
              reference_2_type: refData.reference_2_type,
              references: refData.others,
            }
          });
        }
        return true;
      } else if (result.warnings?.length > 0) {
        setWarningMessage(result.warnings);
        setIsWarningModalVisible(true);
        return false;
      } else {
        renderNotification(result.errors, "error");
        return false;
      }
    }
  const handleWarningConfirm = async () => {
    setSkipWarnHawbUniqueness(true);
    setIsWarningModalVisible(false);
  };
  useEffect(() => {
    if (skipWarnHawbUniqueness) {
      const save = async () => {
        await handleSave();
      };
      save();
    }
  }, [skipWarnHawbUniqueness]);

  const handleWarningCancel = () => {
    setIsWarningModalVisible(false);
    setIsEditMode(true);
  };

  const openModalProgress = () => setIsModalOpenProgress(true);
    const closeModalProgress = () => setIsModalOpenProgress(false); 
    const completionPercent = (completedOrders / totalOrders) * 100;
    const modalContentProgress = () => {
      return (
        <>
              <div className="table-container-shipper">
               <span className="">
               <div className="progress-bar">
               <Progress
               percent={completionPercent} 
               strokeColor="#4A90E2"
               showInfo={false} 
               strokeWidth={20} />
               <p className="progress-text">{`${completedOrders} of ${totalOrders} Orders Completed`}</p>
               </div>
               </span>
               {
        warningMessages.length > 0 &&
        <ErrorComponent
                errors={[`${warningMessages.join(', ')}`]}
            />
      }
              </div>
              </>
      );
    };
    const modalFooterProgress = () => {
      return (
        <>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <Button_v2
                key="cancel"
                text="Delink from MAWB"
                className="flat medium-btn"
                onClick={()=>openModal()}
              />
             <Button_v2
                key="cancel"
                text="View Linked Orders"
                className="flat medium-btn"
                onClick={handleClick}
              />
              </div>
              </>
      );
    }

    const progressModalRender =()=>{
       return (
        <ModalComponent
          visible={isModalOpenProgress}
          onCancel={closeModalProgress}
          title={
            <div className="modal-header">
              <span>MAWB #{consolidatedData[0]?.Mawb}</span>
              <div className="custom-close-icon-wrapper">
                {/* <Tooltip title="Close"> */}
                  {/* <CloseIcon/> */}
                  <img src={CloseIcon} alt="" onClick={closeModalProgress} />
                {/* </Tooltip> */}
              </div>
            </div>
          }
          content={
            modalContentProgress()
          }
          closable={false}
          width={524}
          // height={600}
          // mask={false}
          centered
          // okButtonProps={{ className: "medium-btn raised" }}
          // cancelButtonProps={{ className: "medium-btn flat" }}
          footer={
            modalFooterProgress()
          }
        />
       )
    }

    const handleSaveLink = (record, text) => {      
  
      const orderDelinkData = consolidatedData
    .filter((item) => item.customer_order_number)
    .some((item) => record.order_numbers.includes(item.customer_order_number))
    ? record.order_numbers
    : [];    
    const hawbDelinkData = consolidatedData
    .filter((item) => item.Hawb)
    .map((item) => item.Hawb)
    .includes(record.hawb_numbers)
    ? [record.hawb_numbers]
    : [];

      if (hawbDelinkData.length === 1 && hawbDelinkData[0] === 'N/A') {
        hawbDelinkData.length = 0;
      }
   
      const orderData = text === "delink" ? orderDelinkData : []
      const hawbData =  text === "delink" ? hawbDelinkData : []
  
      setIsLoading(true);
    
      const payload = {
        parent_order_id: orderResponse.id,
        order_numbers: orderData || [],
        account_id: orderResponse?.account?.account_id,
        hawb_numbers: hawbData || [],
        operation: text,
        org_id: _.get(orgData, "currentOrg.id", ""),
      };   
      mawbConnections(payload)
        .then((res) => {
          if (res.success) {
            let messages = [];
            const warnings = res.data.warnings;
    
            if (Array.isArray(warnings)) {
              messages = warnings;
            } else if (
              Object.values(warnings).some(
                (array) => Array.isArray(array) && array.length > 0
              )
            ) {
              if (warnings.failed_hawb_numbers?.length > 0) {
                messages.push(
                  `Failed HAWB Numbers: ${warnings.failed_hawb_numbers.join(", ")}`
                );
              }
    
              if (warnings.failed_order_numbers?.length > 0) {
                messages.push(
                  `Failed Order Numbers: ${warnings.failed_order_numbers.join(", ")}`
                );
              }
            }
    
            setWarningMessages(messages);
    
            if (messages.length === 0) {
              alertMessage(res.data.message, "success");
              doRefreshDetails();
              setIsModalOpen(false);
            }
          } else {
            alertMessage(res.errors, "error");
          }
        })
        .catch((err) => {
          const errorMessage = Array.isArray(err) ? err.join(', ') : 'An error occurred';
          alertMessage(errorMessage, "error");
        })
        .finally(() => {
          // Hide the loader
          setIsLoading(false);
          setIsModalOpen(false);
        });
    };

  const REFERENCE_VALUE_MAX_LENGTH = 12;

  const renderTruncatedReferenceValue = (ref) => {
    if (ref.length > REFERENCE_VALUE_MAX_LENGTH) {
      return (
        <Popover
          overlayClassName="PopoverStyles"
          content={
            <div style={{ wordBreak: "break-word" }}>{ref}</div>
          }
          trigger="hover"
        >
          <span style={{ cursor: "pointer" }}>
            {`${ref.substring(0, REFERENCE_VALUE_MAX_LENGTH)}....`}
          </span>
        </Popover>
      );
    }
    return ref;
  };

  const renderReferenceRow = (
    label,
    fieldName,
    value,
    addText,
    isEditMode,
    isDropdown,
    isReferenceType = false,
    referenceTypeKey = null,
    required = false

  ) => {
    const referenceType = referencesData.find(
      (ref) => ref.order_reference_type === referenceTypeKey
    );
    const referenceValue = referenceType
      ? referenceType.order_reference_type
      : label;
  const formattedValue = value ? Array.isArray(value) ? value : value.split(",").map((val) => val.trim()) : [];
      
    const handleEnableEditMode = () => {
      setIsEditMode(true);
    };

    const handlePopoverVisibleChange = (visible) => {
      setShowPopover(visible);
    };

    return (
      <Row style={{ marginBottom: "4px", lineHeight: "32px",display: "flex", alignItems: "center" }} key={fieldName}
        onMouseEnter={() => setHoveredField(fieldName)}
        onMouseLeave={() => setHoveredField(null)}
      >
        <Col span={10} style={{ paddingRight: "4px" }}>
          <div className="Caption-2-Large" style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}>
            {isEditMode && isReferenceType ? (
              <div style={{ display: "inline-flex", alignItems: "center", gap: "2px" }}>
                <Dropdown
                  overlay={
                    <Menu>
                      {getFilteredReferences(referenceTypeKey).map((rec) => (
                        <Menu.Item key={rec.order_reference_type}>
                          <div
                            onClick={() =>
                              handleSelectChange(
                                rec.order_reference_type,
                                referenceTypeKey
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {rec.order_reference_type}
                          </div>
                        </Menu.Item>
                      ))}
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      color: "#576ec1",
                    }}
                  >
                    <span>{referenceValue}</span>
                    <Icon
                      style={{ marginLeft: "4px", color: "#576ec1" }}
                      type="caret-down"
                    />
                  </div>
                </Dropdown>
                <span>
                  {required && <span style={{ color: "red" }}>*</span>}
                </span>
              </div>
            ) : (
              // referenceValue
              <>
                <span 
                style={{
                  ...(referenceValue.length > 13
                    ? {
                        maxWidth: "90px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                        verticalAlign: "middle"
                      }
                    : {}),
                }}title={referenceValue.length > 13 ? referenceValue : undefined}>{referenceValue}</span>
                  {isEditMode && required && (
                    <span style={{ color: "red"}}>*</span>
                  )}
                  {
                    referenceValue === "MAWB" &&
                    !isEditMode &&
                    totalOrders > 0 &&
                    config?.consolidated_mawbs === "true" && (
                      <span className="progressButton">
                        <Button size="small" onClick={() => openModalProgress()}>
                          {completedOrders} / {totalOrders}
                        </Button>
                      </span>
                    )
                  }
              </>
            )}

            {hoveredField === fieldName && (
              <div style={{ marginLeft: "1px", marginRight: "8px", flexShrink: 0 }}>
                <InfoTooltip
                  label={label}
                  icon={<RefNumTooltipIcon />}
                  message={[
                    label === "HAWB"
                      ? "A HAWB, or House Air Waybill, is a document from a freight forwarder detailing a shipment's contents, shipper, and recipient for air cargo. It helps track and manage individual shipments."
                      : label === "MAWB"
                        ? "A MAWB, or Master Air Waybill, is an airline-issued document for a consolidated shipment. Using the same MAWB number on multiple orders links them for easy tracking."
                        : label === "IT Number"
                          ? "An IT (Immediate Transportation) Number is used to track shipments moving in-bond under customs supervision."
                          : label === "Ref 1 Type"
                          ? "Reference Types are customizable labels set in Org. Settings > Order Settings, ideal for operations differing from industry standards."
                          : label === "Ref 2 Type"
                            ? "Reference Types are customizable labels set in Org. Settings > Order Settings, ideal for operations differing from industry standards."
                            : label === "Other"
                              ? "Use 'Other' to input any reference numbers that don't fit into the predefined categories, you can comma separate multiple entries."
                              : "No message available"
                  ]}
                />
              </div>
            )}
          </div>
        </Col>
        <Col span={14} style={{ paddingLeft: "4px" }}>
          {isEditMode ? (
            fieldName === "references" ? (
              <Select
                data-testid={`${fieldName}-input`}
                style={{
                  width: "100%",
                  border: "1px solid #8897a4",
                  borderRadius: "4px",
                }}
                value={inputValue.references}
                onChange={(val) => handleSelectChange(val, "references")}
                mode="tags"
                maxTagCount={0}
              />
            ) : (
              <ReusableInput
                data-testid={`${fieldName}-input`}
                name={fieldName}
                value={value || ""}
                onChange={(e) => {
                  const val = e.target.value ?? ''; 
                  setInputValue((prevFormValues) => ({
                    ...prevFormValues,
                    [fieldName]: val
                  }));
                  if (fieldName === "it_number") {
                    setSharedItNumber(val);
                  }
                }}
                capsOn={fieldName !== "it_number"}
              />
            )
          ) : (Array.isArray(value) ? value.length > 0 : value) ? (
              <Row
                style={{
                  lineHeight: "32px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Col
                  span={20}
                  style={{
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ color: "#111314" }} className="Caption-2-Large">
                    {/* Show only the first two items */}
                    {formattedValue.slice(0, 2).map((ref, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          gap: "8px",
                          cursor: "pointer",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          maxWidth: "100%",
                        }}
                      >
                        {renderTruncatedReferenceValue(ref)}
                      </div>
                    ))}
                    {/* If there are more than two items, show a popover with the remaining items */}
                    {formattedValue.length > 2 && (
                      <Popover
                      overlayClassName="PopoverStyles"
                        content={
                          <div>
                            {formattedValue.slice(2).map((ref, index) => (
                              <div
                                key={index}
                                style={{
                                  marginBottom: "4px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {ref}
                              </div>
                            ))}
                          </div>
                        }
                        title="Additional References"
                        trigger="click"
                        visible={showPopover}
                        onVisibleChange={handlePopoverVisibleChange}
                      >
                        <Button
                          type="link"
                          style={{
                            color: "#8897a4",
                            cursor: "pointer",
                            marginTop: "4px",
                            textDecoration: "underline",
                            padding: 0,
                          }}
                        >
                          +{formattedValue.length - 2} more
                        </Button>
                      </Popover>
                    )}
                  </div>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  {value && (Array.isArray(value) ? value.length > 0 : true) && (
                    <Copyable className="orderNumberCopyIcon" text={value} />
                  )}
                </Col>
              </Row>
          ) : (
                <div
                  data-testid={`${fieldName}-button`}
                  className={`button-2-large ${locked ? "Caption-2-Large" : ""}`}
                  onClick={!locked ? handleEnableEditMode : undefined}
                  style={locked ? { color: "#111314" } : {}}
                >
                  {locked ? "Not Available" : addText}
                </div>
          )}
        </Col>
      </Row>
    );
  };
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const requiredFields = (orgRules?.org_billing_rules?.require_fields_as_mandatory || "")
        .split(",")
        .map(f => f.trim().toLowerCase())
        .filter(f => f.length > 0);
  const isFieldMandatory = (field) => requiredFields.includes(field.toLowerCase());
      
  return (
    <div className="RefNumbersContainer" style={{ marginBottom: "16px" }} data-testid="reference-numbers-view">
      <Row style={{ display: "flex", justifyContent: "space-between" }}>
        <Col span={18}>
          <div className="heading-3-large">Ref Numbers</div>
        </Col>
        <Col span={6}>
          {!locked &&( <Button
            data-testid={`${isEditMode ? "save" : "edit"}-button`}
            type="link"
            className="button-2-large"
            style={{ background: "none", border: "none", cursor: "pointer" }}
            onClick={async () => {
              if (isEditMode) {
                const isSaved = await handleSave();
                if (isSaved) {
                  setIsEditMode(false);
              }
              } else {
                setIsEditMode(true);
              }
            }}
          >
            {isEditMode ? "Save" : "Edit"}
          </Button>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {renderReferenceRow(
            "HAWB",
            "hawb",
            inputValue.hawb || "",
            "Add",
            isEditMode,
            false,
            '','',
            isFieldMandatory('hawb')
          )}
          {renderReferenceRow(
            "MAWB",
            "mawb",
            inputValue.mawb || "",
            "Add",
            isEditMode,
            false,
            '','',
            isFieldMandatory('mawb')
          )}
          {showItNumber && renderReferenceRow(
            "IT Number",
            "it_number",
            inputValue.it_number || "",
            "Add",
            isEditMode,
            false,
            '','',
            isFieldMandatory('it_number')
          )}
          {renderReferenceRow(
            inputValue.reference_1_type || "",
            "reference_1",
            inputValue.reference_1 || "",
            "Add",
            isEditMode,
            true,
            true,
            "reference_1_type",
            isFieldMandatory('reference_1')
          )}
          {renderReferenceRow(
            inputValue.reference_2_type || "",
            "reference_2",
            inputValue.reference_2 || "",
            "Add",
            isEditMode,
            true,
            true,
            "reference_2_type", 
            isFieldMandatory('reference_2')
          )}
          {renderReferenceRow(
            "Other",
            "references",
            inputValue.references || [],
            "Add",
            isEditMode,
            false
          )}
          
          {!isEditMode && lineHaulData.number && (
            <Row
              style={{
                marginBottom: "4px",
                lineHeight: "32px",
                display: "flex",
                alignItems: "center",
              }}
              key="parentLinehaul"
            >
              <Col span={11}>
                <div className="Caption-2-Large">LineHaul</div>
              </Col>
              <Col span={13} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <CustomerOrderDetails
                  order_no={lineHaulData.number}
                  order={{
                    id: lineHaulData.id,
                    customer_order_number: lineHaulData.number,
                  }}
                  showEdit={true}
                />
              </Col>
            </Row>
          )}

        </Col>
      </Row>
      <Modal
        closable={false}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <AlertWarningIcon />
            <span>Warning !</span>
          </div>
        }
        visible={isWarningModalVisible}
        footer={[
          <Button className="button-2-large" key="cancel" type="link" onClick={handleWarningCancel}>
            No
          </Button>,
          <Button className="button-2-large" key="cancel" type="link" onClick={handleWarningConfirm} >
            Yes, Proceed
          </Button>,
        ]}
        width={376}
      >
        <div>
          {warningMessage?.map((warning, index) => (
            <div key={index} style={{ marginBottom: '4px' }}>
              {warning}
            </div>
          ))}
        </div>
      </Modal>
      { isModalOpenProgress && ( progressModalRender())}
      {isModalOpen &&  (
        <SuborderModal
        isVisible={isModalOpen} 
        onClose={closeModal} 
        onSave={handleSaveLink}
        consolidatedData={consolidatedData} 
        orderResponse={orderResponse} 
        orgData={orgData} 
        setIsLoading={setIsLoading}
        screenType={"orderViewSidebar"}/>
      )}
    </div>
  );
}

export default ReferenceNumberSectionView;
